import { useContext, useEffect, useState } from "react";
import { PortalContext } from "../../../context/Provider";
import {
  Body,
  Container,
  Footer,
  LineaSeparadora,
  Top,
  TurnosContainer,
} from "./localStyle";
import camelize from "global/utils/camelize";
import AlertIcon from "_+_Portal/assets/images/generico/AlertIcon";
import TildePresente from "_+_Portal/assets/images/generico/TildePresente";

const ModalPresentismo = ({ dissmiss }) => {
  const { presentismoState } = useContext(PortalContext);
  const [presentes, setPresentes] = useState(0);
  const [ausentes, setAusentes] = useState(0);
  const [lista, setLista] = useState();

  useEffect(() => {
    if (presentismoState.presentismo.data) {
      let reversedList = [...presentismoState.presentismo.data].reverse();
      setLista(reversedList);
      let turnosAusentes = presentismoState.presentismo.data.filter(
        (item) => !item.presente
      );
      setAusentes(turnosAusentes.length);
      let turnosPresentes = presentismoState.presentismo.data.filter(
        (item) => item.presente
      );
      setPresentes(turnosPresentes.length);
    }
  }, [presentismoState.presentismo.data]);

  return (
    <Container turnos={presentismoState.presentismo.data.length > 0}>
      <Top>
        <span>Listado de turnos</span>
        <div
          className="cruz"
          onClick={() => {
            dissmiss();
          }}
        >
          X
        </div>
      </Top>

      <Body turnos={presentismoState.presentismo.data.length > 0}>
        {presentismoState.presentismo.data.length > 0 ? (
          Array.isArray(lista) &&
          lista.map((item, index) => {
            return (
              <>
                <TurnosContainer key={index}>
                  <p>
                    Fecha turno: {new Date(item.fecha).toLocaleDateString()}
                  </p>
                  <p className="rb16b">{item.profesional}</p>
                  <div className="tipoConsultaEstado">
                    {/* <p>{camelize(item.especialidad)} </p> */}
                    <p
                      className={`${
                        !item.presente ? "c-danger" : "c-broccoli"
                      } rb16b iconEstado`}
                    >
                      {!item.presente ? (
                        <AlertIcon
                          color={"var(--color-danger)"}
                          width={18}
                          height={18}
                        />
                      ) : (
                        <TildePresente width={18} height={18} />
                      )}
                      {item.estadoTurno}
                    </p>
                  </div>
                </TurnosContainer>
                <div>
                  <LineaSeparadora />
                </div>
              </>
            );
          })
        ) : (
          <p className="rb18l">No hay turnos para mostrar</p>
        )}
      </Body>
      <Footer>
        {presentismoState.presentismo.data.length > 0 && (
          <div className="boxPresentesAusentes">
            <p className="rb16b">Presentes: {presentes}</p>
            <p className="rb16b">Ausentes: {ausentes}</p>
          </div>
        )}
        <button
          onClick={() => {
            dissmiss();
          }}
          className="c-white bgc-primary"
        >
          Aceptar
        </button>
      </Footer>
    </Container>
  );
};
export default ModalPresentismo;
